import { FC } from 'react';

import '../Modals.scss';
import './SharesTransferExcelModal.scss';

import SharesTransferExcelModalHeader from './components/SharesTransferExcelModalHeader';
import SharesTransferExcelModalBody from './components/SharesTransferExcelModalBody';
import SharesTransferExcelModalFooter from './components/SharesTransferExcelModalFooter';
import { useSharesTransferExcelModal } from './context/SharesTransferExcelModalContext';

const SharesTransferExcelModal: FC = () => {
  const { data } = useSharesTransferExcelModal();

  return (
    <>
      <SharesTransferExcelModalHeader />
      <SharesTransferExcelModalBody />
      <SharesTransferExcelModalFooter />

      {data.isLoading && !data.isParsingExcel && (
        <div className="shares-transfer-excel-modal__overlay-loading">
          <div
            className="spinner-border text-primary"
            role="status"
            data-testid="shares-transfer-excel-overlay-loading"
          />
        </div>
      )}
    </>
  );
};

export default SharesTransferExcelModal;
